'use es6';

export const canDragIntoLayout = catalogWidget => {
  if (!(catalogWidget && catalogWidget.type)) return false;
  if (catalogWidget.isThemeAsset) return false;

  switch (catalogWidget.type) {
    case 'custom_widget':
      {
        const {
          schemaVersion,
          isAvailableForNewContent
        } = catalogWidget;
        return schemaVersion === 1 || isAvailableForNewContent;
      }

    case 'global_group':
      {
        return catalogWidget.isAvailableForNewContent;
      }

    default:
      return true;
  }
};